// TODO: Import React module
import * as React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

// TODO: Import MUI module
import { Box, Tabs, Tab, } from '@mui/material';

// TODO: Import MUI icon
import { AccountCircle } from '@mui/icons-material';

// TODO: Import context

// TODO: Import custom component
import BoxImage from '../Common/BoxImage';
import BoxSubPage from '../Common/BoxSubPage';
import { BoxGridColumnsContainer, BoxGridColumnsFullWidth } from '../Common/BoxGridColumns';
import { ContentTitle, MultipleRows, } from '../Common/TypographyTYH';

const DSEOutstandingStudentVisit = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component DSEOutstandingStudentVisit Rendered');

    // TODO: Define useContext
    //const context = React.useContext(Context);

    // TODO: Define variable
    const [value, setValue] = React.useState(0);

    const isSmallScreen = useMediaQuery('(max-width:900px)');
    const orientation = isSmallScreen ? 'vertical' : 'horizontal';

    // TODO: Define event
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // TODO: Return component
    const BoxStudent1 = ({ tabValue }) => {
        // TODO: Define variable
        const images = [
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/晴晴_01.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/晴晴_02.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/晴晴_03.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/晴晴_04.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/晴晴_05.jpg',
        ];

        // TODO: Return component
        return (
            <Box sx={{ display: tabValue === 0 ? 'block' : 'none', width: 1, }}>
                <BoxGridColumnsContainer>
                    <BoxGridColumnsFullWidth>
                        <ContentTitle text={'1.滿意成績嗎?是否預期之內呢?'} />
                        <MultipleRows rows={['我認爲成績尚算令人滿意，不少科目也超出預期，成績高於校內考試。']} />
                        <ContentTitle text={'2.接下來有何人生目標?'} />
                        <MultipleRows rows={['我將繼續努力以及增值自己，希望能在大學中提升自己的英文能力，同時也在外積極參與義工、交流活動，修讀更多有興趣的學科，開拓視野。']} />
                        <ContentTitle text={'3.你覺得在母校培養出的哪些特質或能力（如堅毅、自主學習等），能讓你更有信心面對未來的挑戰？'} />
                        <MultipleRows rows={['在母校的六年，我很感恩自己參加了學生領袖團隊，讓我更加自信勇敢。起初我很膽小，遇到感興趣的活動也不敢參與。直到加入學生領袖，得到許多老師、同學的支持和鼓勵，一步步成長，遇到機會會主動爭取及嘗試。我深信這一番成長會伴隨我走向未來。日後遇上心之所向的事，我會積極把握，因為我明白，機會從不會主動降臨，而是需要自己爭取的。即使前路遇上重重難關，但我會牢記身邊的人的每一句鼓勵，懷著勇氣繼續前行，相信「關關難過關關過」。']} />
                        <ContentTitle text={'4.能否分享一下學習心得？ 高中三年，如何保持良好的學習狀態？'} />
                        <MultipleRows rows={['面對排山倒海的小測和功課，我會每天記下什麼時候小測，要考核什麼內容，功課什麼時候交。然後在小測前兩天開始準備，重溫該課內容，不單是背還要理解，懂得運用。因此重溫一次後，我會利用白紙整理一份簡單的筆記，然後在課本上或參考書上尋找相似題目，確保自己掌握每一個知識點、清楚每一個作答步驟。當小測、考試卷派回來的時候，我也會仔細地研究自己錯了些什麼，有什麼不明白，然後再理解答案。還是不明白的話，我會主動請教老師、同學，或者是問人工智能，多加思考。有時候多看看其他同學的功課小測也能受益。']} />
                        <ContentTitle text={'5.在高中三年中，你積極參與了哪些課外活動或服務？你如何在緊湊的學術追求與課外活動之間取得完美的平衡？'} />
                        <MultipleRows rows={['在校內，我參加了學生領袖以及社會服務組；在校外，我也會主動參與一些義工服務。同時，我會善用行事曆去規劃自己的時間，把活動的時間都記下來，盡量避免活動時間重疊。此外，我也會預留時間作溫習小測之用。如果當日有活動需要出席時，我會利用乘車時間及晚上溫習，準備另一天的小測。']} />
                        <ContentTitle text={'6.有沒有甚麼人想特別鳴謝？'} />
                        <MultipleRows rows={['在成長的路上，很感激自己遇到一班無條件包容自己的老師。我是一個頗粗心大意的人，經常性犯同一個錯誤，例如：沒有審題、寫錯字，多項選擇題填錯格數、看漏題目等等，但老師們總是不厭其煩地指正及提醒我。當我感到失意時，老師們總會第一時間察覺我的情緒，耐心地安慰我，鼓勵我，讓我重拾信心。此外，也很感恩遇到一班很了解我的朋友，他們總會在我質疑自己的時候，立刻站出來反駁我；在我因為成績而感到挫敗時，也會說笑逗我開心，讓我能笑著應對DSE的考試壓力。同時，也很感謝學生領袖團隊的一群同伴，在DSE前給予我無盡的鼓勵和驚喜，壓力大的時候，看著大家在字條留下的話語，總能讓我感到溫暖，找到繼續往前邁進的力量。',]} />
                        <ContentTitle text={'7.你在中文科取得5** 成績，可以分享一下你學習相關科目的方法嗎？'} />
                        <MultipleRows rows={['在卷一閱讀卷，範文的部分能夠透過溫習而得分，因此我會利用學校筆記、參考書、網上資源等整合一份範文筆記，然後在一些練習上記下自己覺得能得分的內容，之後再核對答案，看看是否已緊扣評分要求。同時，我也會把曾經做過的試卷翻出來，研究評分參考，細心審視自己差了些什麼。在長答上，必須援引文本依據再加以說明。文言文部分需要背誦一些比較常見的字眼或者是句式，另外，我也會額外了解「儒、道、墨、法」四家的思想，這樣在文言文長答時，也能透過猜測了解文意，撿撿分。',
                            '在卷二作文上，甲部需要記清楚格式，不要猜度會出什麼文體，然後把其他忽略，需要對所有體裁格式有清晰掌握。在作文前先審題兩至三次，把題目字眼圈起提醒自己。然後寫大綱構思文章主旨、段落大意、想抒發的情感，內容是不是都能帶出主旨。同時，能夠突顯主題情感的內容需要詳寫，在寫大綱的時候也要時不時的看看題目，避免偏題或離題。最後檢查的時候，可以在題目字眼旁邊加上剔號，代表自己有扣題。']} />
                        <ContentTitle text={'8.作為過來人，你對即將面對 DSE 的師弟師妹有什麼心底話或實用的建議？'} />
                        <MultipleRows rows={['DSE是一場「努力了，就會有收穫」的公平遊戲，或許現在我們會因為校內卷上的分數而深受挫敗，或許分數不如你所願，但請謹記距離DSE仍有一段時間時間，你每一日的努力都不曾白費，只要不放棄，努力到最後，結果一定會是好的。願大家能在各自的路上綻放光芒，成爲一顆星星，照亮自己，照耀他人。不負熱愛也不負所望，共勉之！',]} />
                    </BoxGridColumnsFullWidth>
                    {
                        images.map((image, i) => (
                            <BoxImage key={i} src={image} />
                        ))
                    }
                </BoxGridColumnsContainer>
            </Box>
        )
    };

    const BoxStudent2 = ({ tabValue }) => {
        // TODO: Define variable
        const images = [
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/李梓銦_01.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/李梓銦_02.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/李梓銦_03.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/李梓銦_04.jpg',
        ];

        // TODO: Return component
        return (
            <Box sx={{ display: tabValue === 1 ? 'block' : 'none', width: 1, }}>
                <BoxGridColumnsContainer>
                    <BoxGridColumnsFullWidth>
                        <ContentTitle text={'1.滿意成績嗎?是否預期之內呢?'} />
                        <MultipleRows rows={['我對成績感到滿意，整體表現也在預期之內。']} />
                        <ContentTitle text={'2.接下來有何人生目標?'} />
                        <MultipleRows rows={['我將繼續學習，努力成為理想中的自己。']} />
                        <ContentTitle text={'3.你覺得在母校培養出的哪些特質或能力（如堅毅、自主學習等），能讓你更有信心面對未來的挑戰？'} />
                        <MultipleRows rows={['我覺得母校培養出的堅毅特質是成長過程中最重要的，面對困難我絕不輕言放棄，畢竟「流水不爭先，爭的是滔滔不絕」。']} />
                        <ContentTitle text={'4.能否分享一下學習心得?高中三年，如何保持良好的學習狀態?'} />
                        <MultipleRows rows={['我認為，對於一知半解或是不明白的地方要勇於發問，使自己真的理解，而非一味地背誦。此外，由於AI(人工智能)可以在極短時間內回應我的疑惑，因此我會善用它解答我的疑問。倘若疑惑尚未得以解決，便會再去請教同學或老師。再者，我會同時使用幾個不同的AI，比較它們的回覆，避免出現錯誤的答案或邏輯。至於在保持良好的學習狀態方面，我會避免與他人作比較，否則難免會感到迷惘和焦慮，而負面情緒會很大程度上影響我學習心態。同時，我會盡量保持充足睡眠，讓身心都獲得休息，從而保持一個相對較高的效率。']} />
                        <ContentTitle text={'5.在高中三年中，你積極參與了哪些課外活動或服務？你如何在緊湊的學術追求與課外活動之間取得完美的平衡？'} />
                        <MultipleRows rows={['高中三年中，我作為環境保護大使，有時候需要在週末外出參加活動，例如到本地農場、室內農場參加活動以及講座等，但我認為參與自己感興趣的活動亦是休息方法之一，只要在學術和課外活動中取得平衡即可。同時，這也有助避免參加過多的課外活動而透支自身體力，耽誤我的學術追求。']} />
                        <ContentTitle text={'6.有沒有甚麼人想特別鳴謝?'} />
                        <MultipleRows rows={['我特別感謝各位悉心教導，替我解惑的老師。每當我有所疑惑時，老師總會一步步引導我思考。同時，我也感謝陪我一同成長的朋友。']} />
                        <ContentTitle text={'7.你在地理科取得5*成績，可以分享一下你學習相關科目的方法嗎？'} />
                        <MultipleRows rows={['我在學習地理科時會善用歷屆試題的評分參考，由於有些題目總是反覆出現，而答案的字眼總是差不多，我會把這些答案整理歸納在一起，當出現類似題目時，我便能快速答出某些地理的專有名詞，減少花費長時間寫了好幾行卻沒無法得分的情況，讓自己有更充裕的時間去作答未曾見過的新題目。我個人也很喜歡用概念圖寫筆記，因為不但能在整理過程有助自己更清楚理解某些概念，也方便日後快速溫習，無需看著冗長的文字，能單靠一頁筆記掌握特定概念。除此之外，在應考DSE前，每當我對某些課題無從入手、不知如何溫習時，我很喜歡做多項選擇題，因為這類題目可以快速幫我釐清概念，了解自己不熟悉的課題，而且耗時較短。']} />
                        <ContentTitle text={'8.作為過來人，你對即將面對 DSE 的師弟師妹有什麼心底話或實用的建議？'} />
                        <MultipleRows rows={['我認為找到目標後便要堅定前進，與其擔憂未來，不如專注當下。師弟師妹們，加油！']} />
                    </BoxGridColumnsFullWidth>
                    {
                        images.map((image, i) => (
                            <BoxImage key={i} src={image} />
                        ))
                    }
                </BoxGridColumnsContainer>
            </Box>
        )
    };

    const BoxStudent3 = ({ tabValue }) => {
        // TODO: Define variable
        const images = [
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/孫暉喬_01.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/孫暉喬_02.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/孫暉喬_03.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/孫暉喬_04.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/孫暉喬_05.jpg',
        ];

        // TODO: Return component
        return (
            <Box sx={{ display: tabValue === 2 ? 'block' : 'none', width: 1, }}>
                <BoxGridColumnsContainer>
                    <BoxGridColumnsFullWidth>
                        <ContentTitle text={'1.滿意成績嗎?是否預期之內呢?'} />
                        <MultipleRows rows={['我覺得還算滿意，成績與學校及自己的預估相約。']} />
                        <ContentTitle text={'2.接下來有何人生目標?'} />
                        <MultipleRows rows={['希望可以透過大學生活找到清晰的就業方向，讓自己的視野更廣闊，學習和培養不同領域的知識和技能，提高自己的競爭力。']} />
                        <ContentTitle text={'3.你覺得在母校培養出的哪些特質或能力（如堅毅、自主學習等），能讓你更有信心面對未來的挑戰？'} />
                        <MultipleRows rows={['我覺得在母校培養出的解難能力和恆毅力，均能讓我更有信心面對未來的挑戰。在校擔任學生領袖的幾年裡，我積累了不少帶領、組織活動的經驗，當中需要解決不同的困難和挫折，經歷數不盡的突發情況。雖然過程可能是「苦」的，但回味起來卻是「甘」的。每一個活動的挑戰都是歷練的機會，讓我們能以更好的心態解決問題，讓我們經歷艱辛，堅持到最後，我相信正是這些寶貴的經驗造就了自信的我，讓我能更從容、自如地面對未來的挑戰。']} />
                        <ContentTitle text={'4.能否分享一下學習心得?高中三年，如何保持良好的學習狀態?'} />
                        <MultipleRows rows={['若想保持良好的學習狀態，身心健康是至關重要的一環。還記得有一次，我考試時生病了，藥物讓我的身體疲憊不堪，影響了我的精神狀態，導致我無法在考試中發揮好，所以考出來的成績也不太理想。我知道生病這件事不是我們能控制的，但我們能做的是按時完成每個任務，確保有充足而質素良好的睡眠，保持身體的免疫力。如此才能擁有良好的學習狀態，並在考試這種關鍵時刻發揮出真正的實力和水準。']} />
                        <ContentTitle text={'5.在高中三年中，你積極參與了哪些課外活動或服務？你如何在緊湊的學術追求與課外活動之間取得完美的平衡？'} />
                        <MultipleRows rows={['高中三年裡，我擔任了學生領袖組長和首席、副社長、樂隊主唱，也參加了冰球隊。在繁多的職務和活動下，一定要學會好好時間分配。我會把功課、小測、活動記錄下來，提前安排好時間。雖然不能精準到每分每秒，但也可以有一個大致的方向，提醒我要做些什麼。']} />
                        <ContentTitle text={'6.有沒有甚麼人想特別鳴謝?'} />
                        <MultipleRows rows={['我想要感謝的人有很多，包括了家人、老師和朋友。在我備試的這段時間，我的家人包容了我很多，他們會遷就我的需要，儘量讓我有安靜的環境溫習，也會接受我的所有情緒，給予適當的幫助。至於老師跟朋友，我們陪伴彼此的時間很長，就像凝聚了無形的力量，讓我們都更有動力溫習。有時，只是一句話、一顆糖果、一個擁抱，但帶來的力量卻恰恰是我們當刻最需要的。']} />
                        <ContentTitle text={'7.作為過來人，你對即將面對 DSE 的師弟師妹有什麼心底話或實用的建議？'} />
                        <MultipleRows rows={['不要懷疑，相信自己。要記得DSE是一場持久戰，過程可能很艱辛、很難熬，會有汗，會有淚，但你並不孤單，有很多人陪伴著你，能堅持到最後已經戰勝了自己。已經開始努力的你記得要善用你有的資源，有疑問可以問老師、同學，或是問AI，也可以好好運用手機及平板電腦等工具來提高學習效率；還沒開始發力的你也不要灰心，現在開始亦為時未晚，只要肯努力，一定能看到成果。相信自己！堅持下去！ ']} />
                    </BoxGridColumnsFullWidth>
                    {
                        images.map((image, i) => (
                            <BoxImage key={i} src={image} />
                        ))
                    }
                </BoxGridColumnsContainer>
            </Box>
        )
    };

    const BoxStudent4 = ({ tabValue }) => {
        // TODO: Define variable
        const images = [
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/李靖昤_01.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/李靖昤_02.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/李靖昤_03.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/李靖昤_04.jpg',
        ];

        // TODO: Return component
        return (
            <Box sx={{ display: tabValue === 3 ? 'block' : 'none', width: 1, }}>
                <BoxGridColumnsContainer>
                    <BoxGridColumnsFullWidth>
                        <ContentTitle text={'1.滿意成績嗎?是否預期之內呢?'} />
                        <MultipleRows rows={['對於這次的成績我是滿意的，倘若考試當刻能擁有更好的心態，相信表現會更為理想。']} />
                        <ContentTitle text={'2.接下來有何人生目標?'} />
                        <MultipleRows rows={['答：我希望可以入讀心儀的大學，在完成學業後得以自立、回饋家人，閒暇時四處遊歷、看看世界。']} />
                        <ContentTitle text={'3.你覺得在母校培養出的哪些特質或能力（如堅毅、自主學習等），能讓你更有信心面對未來的挑戰？'} />
                        <MultipleRows rows={['母校給予我很多參加活動、加入大型團體的機會，當中最能令我學懂與人相處的技巧和團隊合作精神。此外，老師們對我的肯定也使我在參加活動後表現得更為自信。相信這些磨鍊和經歷能讓我在日後進修和職場上都有莫大幫助。']} />
                        <ContentTitle text={'4.能否分享一下學習心得?高中三年，如何保持良好的學習狀態?'} />
                        <MultipleRows rows={['高中課業繁忙，難免會出現低潮時期。每每付出後卻看不見明顯的進步，這種感覺會重重壓在自尊心上，或感失意。然而身邊總是有那幾個並肩奮鬥的夥伴，她們說著下個進步的目標、與我一起日夜面對那座書山，努力學習的決心便會重燃，想到在奮鬥的路上自己並非孤軍作戰，便不那麼害怕了。再者，比起一時的失敗，更可怕的是固步自封。我將立足於自力更生，並以貢獻社會為目標。若因些許挫敗便放棄，就無法成為自己能依賴的人。於是我會為明天的自己鼓勵今天的自己，欣賞自己的堅持、默默鼓勵按照時間表溫習的我。想必那些鼓勵，正是我保持良好學習狀態的關鍵。']} />
                        <ContentTitle text={'5.在高中三年中，你積極參與了哪些課外活動或服務？你如何在緊湊的學術追求與課外活動之間取得完美的平衡？'} />
                        <MultipleRows rows={['高中三年中，我曾是學生領袖、學生會成員，更在學業最繁忙的中五擔任了英語大使的組長。雖然需要參與很多活動，但我認為正是這些活動讓我在繁忙的課業中獲得調劑。高中的日子裡，我把大部分時間都埋頭在書本的海洋中，與幾位好友向著學業目標奮鬥，彷彿置身於一個只有書本的世界。但每當我參與不同的活動、與其他年級的人互動時，看見天真浩蕩的師弟師妹，他們有的熱情奔放、有的羞澀內向，我又會重新感受到校園的活力和可愛之處。此外，在學業進度符合預期時，我亦會參加不少義工活動。幸好有了這些點綴，每每向人提起我的高中生活時，除了那段努力讀書的歲月，還有精彩動人的時光。']} />
                        <ContentTitle text={'6.有沒有甚麼人想特別鳴謝?'} />
                        <MultipleRows rows={['我特別感謝高中最要好的幾位朋友。由於當時DSE考試逼近，我們並沒有很多一起去大肆玩樂、享受「瘋狂一點」的青春的機會。現在回想起來，大多與她們相見的時刻，她們都身穿校服，而眼下的黑眼圈還越來越重！那一張張熟悉的臉和我一起試著拆解題目、相互調侃對方的粗心大意或是一同想法子紓緩考試所帶來的壓力。謝謝妳們，妳們是我在學業壓力下仍然堅持的精神支柱！']} />
                        <ContentTitle text={'7.作為過來人，你對即將面對 DSE 的師弟師妹有什麼心底話或實用的建議？'} />
                        <MultipleRows rows={['如果感到壓力大、有心事時，請找人傾訴！要是把負面情緒壓在心底，便會提不起精神繼續努力。還有，在高中學業緊張的階段，容易錯把成績當作衡量自己一切的指標，一時失意或會打擊自己的自尊心。但請謹記，無論你的成績如何，你還是你！你的家人、朋友必為你而驕傲。所以，別埋怨那個已經付出努力的你。面對困難時，找朋友和老師討論如何繼續進步的方法吧！加油！']} />
                    </BoxGridColumnsFullWidth>
                    {
                        images.map((image, i) => (
                            <BoxImage key={i} src={image} />
                        ))
                    }
                </BoxGridColumnsContainer>
            </Box>
        )
    };

    const BoxStudent5 = ({ tabValue }) => {
        // TODO: Define variable
        const images = [
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/葉文棟_01.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/葉文棟_02.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/葉文棟_03.jpg',
            'https://www.pohtyh.edu.hk/Files/DSEOutstandingStudentVisit/2026/葉文棟_04.jpg',
        ];

        // TODO: Return component
        return (
            <Box sx={{ display: tabValue === 4 ? 'block' : 'none', width: 1, }}>
                <BoxGridColumnsContainer>
                    <BoxGridColumnsFullWidth>
                        <ContentTitle text={'1.滿意成績嗎?是否預期之內呢?'} />
                        <MultipleRows rows={['對於這次的成績，我覺得自己可以做得更好。有部分科目的成績與預期的偏差較大，覺得自己並未做到最好，還是有點可惜。']} />
                        <ContentTitle text={'2.接下來有何人生目標?'} />
                        <MultipleRows rows={['答：我會繼續升學，並在大學期間努力精進英文，為將來就業作準備。除了學習，我亦會鍛煉身體，畢竟身心健康才可以走得更遠。']} />
                        <ContentTitle text={'3.你覺得在母校培養出的哪些特質或能力（如堅毅、自主學習等），能讓你更有信心面對未來的挑戰？'} />
                        <MultipleRows rows={['我認為學校一直推廣同理心、恆毅力、正向思維等的教育令我受益匪浅，幫助我培養出堅毅等優良品質以面對未來挑戰。']} />
                        <ContentTitle text={'4.能否分享一下學習心得?高中三年，如何保持良好的學習狀態?'} />
                        <MultipleRows rows={['高中三年，可以說是學業生涯最繁忙的三年，同時要兼顧不同的課外活動，所以明確的時間規劃是特别重要的。我體會到要做好每一件事，要好好編排優次，絕對不能把所有事情都堆到最後才做。正確的時間做對的事，制定好自己的時間表，才可以活動、學業兩不誤。']} />
                        <ContentTitle text={'5.在高中三年中，你積極參與了哪些課外活動或服務？你如何在緊湊的學術追求與課外活動之間取得完美的平衡？'} />
                        <MultipleRows rows={['高中三年，我擔任過班會主席、學生會幹事、學生領袖組長等。不同職務令我的時間表十分緊湊，甚至某些時候，不同活動的時間會重疊，這讓我學會取捨，令追求學業成績和參與課外活動不會顧此失彼。']} />
                        <ContentTitle text={'6.有沒有甚麼人想特別鳴謝?'} />
                        <MultipleRows rows={['我要感謝的人有很多，包括支持我的父母、陪伴我的同學朋友們、幫助我的老師們。記得初來香港時，人生地不熟的我，得到老師和同學們的鼓勵，讓我很快適應學校生活。我想特别感謝不斷鼓勵我，沒有因為我英文能力弱而放棄我的柳淑芳老師，謝謝給予我不同機會、發掘我不同方面潛能的蔡睿溱老師和張秀琴老師。我很慶幸可有被這麽多好老師教導，也自責没能拿出更好成績，辜負了大家期望。']} />
                        <ContentTitle text={'7.你在中文科取得5* 成績，可以分享一下你學習相關科目的方法嗎？'} />
                        <MultipleRows rows={['我覺得中文卷最重要的部分是卷二，而大多數人都會擔心在作文卷中離題而失分。如何可以防止作文離題呢？我會在寫文章前先用上7-8分鐘寫一個大網，以梳理好之後會寫的内容，避免寫到一半不知道如何寫下去或是憑空想像，最後離題的悲劇。卷一閱讀理解極大部分題目的答案都可在文章中找到，所以做閱讀理解時一定要依據文本，不可胡編亂作答案；課文問答一定要確保每題都要取得一半以上的分數；文言文則盡量取得選擇題的所有分數。']} />
                        <ContentTitle text={'8.作為過來人，你對即將面對 DSE 的師弟師妹有什麼心底話或實用的建議？'} />
                        <MultipleRows rows={['英文科和中文科是最需要花時間去學習，同時也是等待收穫時間最長的科目，請不要因為在這兩科付出努力但暫無回報而氣餒，自信與堅持，最終會收獲纍纍碩果。']} />
</BoxGridColumnsFullWidth>
                    {
                        images.map((image, i) => (
                            <BoxImage key={i} src={image} />
                        ))
                    }
                </BoxGridColumnsContainer>
            </Box>
        )
    };

    return (
        <BoxSubPage
            disableMenu={true}
            disableSubtitle={true}
            id="2026 DSE優秀學生訪問"
            title="2026 DSE優秀學生訪問"
        >
            <Box sx={{ display: 'flex', flexDirection: { xs: 'row', md: 'column' } }}>
                <Tabs
                    onChange={handleChange}
                    orientation={orientation}
                    sx={{ borderBottom: 1, borderColor: 'divider', mb: { xs: 0, md: 2 }, mr: { xs: 2, md: 0 } }}
                    value={value}
                    variant="scrollable"
                >
                    <Tab icon={<AccountCircle />} iconPosition="start" label="狀元 許晴晴" sx={{ fontSize: { xs: '1rem', lg: '1.5rem' } }} />
                    <Tab icon={<AccountCircle />} iconPosition="start" label="榜眼 李梓銦" sx={{ fontSize: { xs: '1rem', lg: '1.5rem' } }} />
                    <Tab icon={<AccountCircle />} iconPosition="start" label="探花 孫暉喬" sx={{ fontSize: { xs: '1rem', lg: '1.5rem' } }} />
                    <Tab icon={<AccountCircle />} iconPosition="start" label="李靖昤" sx={{ fontSize: { xs: '1rem', lg: '1.5rem' } }} />
                    <Tab icon={<AccountCircle />} iconPosition="start" label="葉文棟" sx={{ fontSize: { xs: '1rem', lg: '1.5rem' } }} />
                </Tabs>
                <BoxStudent1 tabValue={value} />
                <BoxStudent2 tabValue={value} />
                <BoxStudent3 tabValue={value} />
                <BoxStudent4 tabValue={value} />
                <BoxStudent5 tabValue={value} />
            </Box>
        </BoxSubPage>
    );
}
export default DSEOutstandingStudentVisit;